<!--Home:移动端官网首页 2021/12/20 10:29:42 YuAng-->

<template>
  <div class="ho-mobile-home">
    <mobile-banner :item="banner"></mobile-banner>
    <div class="ho-page-part2">
      <p class="ho-part-title">数据驱动智慧教学 让教与学更高效</p>
      <p>
        <img width="100%" src="../../../../assets/images/mobile/home_part2_intro.png" />
      </p>
    </div>
    <div class="ho-page-part3">
      <p class="ho-part-title">十大智能系统 为智慧教学护航</p>
      <div class="ho-scroll">
        <ul>
          <li v-for="(item,index) in systems" :key="'li' + index">
            <p class="title">
              <img width="42px" height="42px" :alt="item.item" :src="require('../../../../assets/images/mobile/home_system' + index + '.png')" />
              <span>&nbsp;&nbsp;{{item.title}}</span>
            </p>
            <p v-html="item.desc"></p>
          </li>
        </ul>
      </div>
    </div>
    <collapse-intro title="五大方案优势 打造智慧教学闭环" :list="goods"></collapse-intro>
    <div class="ho-page-part5">
      <p class="ho-part-title">荣誉奖项</p>
      <p class="ho-part5-item">2021年 第80届中国（成都）教育装备展示会，学科网产品总监毛太辉接受新华社采访</p>
      <p class="ho-part5-item">2020年 第78届中国（重庆）教装会，学科网创始人陈学艺博士接受央视采访</p>
      <p class="ho-part5-item">2020年 荣获第七届国际智慧教育展览会中国校园好方案卓越案例奖</p>
      <p class="ho-part5-item">2019年 荣获中国互联网教育评选盛典优质内容产品奖项</p>
      <p class="ho-part5-item">2018年 荣获中国认证联盟教育行业优秀企业奖称号</p>
      <van-swipe :height="262" indicator-color="#70A6FE">
        <van-swipe-item v-for="item in loops" :key="'loop' + item.id">
          <div class="ho-loop-div">
            <img height="210px" :src="require('@/assets/images/home/' + item.picName)" />
            <p style="text-align: center;font-weight: bold;padding: 8px">{{item.title}}</p>
            <van-icon v-show="item.type === 'video' && video.visible === false" @click="lookVideo(item)" size="44px" color="white" class="ho-play-circle" name="play-circle-o" />
          </div>
        </van-swipe-item>
      </van-swipe>
      <popup-video :video="video"></popup-video>
    </div>
    <div class="ho-page-part6">
      <p class="ho-part-title">合作方式</p>
      <ul>
        <li v-for="(item,index) in works" :key="'li' + index">
          <p class="work-title">
            <span>{{item.title}}</span>
          </p>
          <p class="work-desc1">{{item.desc1}}</p>
          <p class="work-desc2">{{item.desc2}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import CollapseIntro from '../components/CollapseIntro.vue'
import MobileBanner from '../components/MobileBanner.vue'
import PopupVideo from '../components/PopupVideo.vue'
export default {
  components: { MobileBanner, PopupVideo, CollapseIntro },
  name: 'Home',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      banner: {
        name: 'home',
        title: '省时省力  因为懂你',
        subtTitle: '好内容+好平台 更懂您的智慧教学',
        desc: '学科网e课堂基于学科网精品内容资源优势，融合大数据、AI等技术打造而成，助力教师精准教学，区域、学校智慧化管理，家校共育，构建三位一体的智慧教学模式',
        url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-09.mp4'
      },
      systems: [
        {
          name: 'number',
          title: '数字资源系统',
          desc: '优质数字资源库实时更新，智能匹配；全国精选试题库精品专题，快速组卷'
        },
        {
          name: 'beike',
          title: '在线备课系统',
          desc: '在线编辑，实时保存，轻松备好课；集体备课，成果共享，沉淀特色资源'
        },
        {
          name: 'shouke',
          title: '智能授课系统',
          desc: '多样互动应用，实现趣味教学；特色学科工具，助力优质课堂；AI 智能测评，反馈即时呈现'
        },
        {
          name: 'yuxi',
          title: '预习训练系统',
          desc: '在线灵活布置，任务一键收发；数据实时反馈，明确教学重难点'
        },
        {
          name: 'pingce',
          title: '英语智能评测系统',
          desc: '六大场景快速选题，高标准听力资源；作文智能批改，口语精准评测'
        },
        {
          name: 'zixue',
          title: '自主学习提升系统',
          desc: '专项突破、同步巩固，分层指导；个性化学习方案，帮助学生减负增效'
        },
        {
          name: 'xueqing',
          title: '学情分析系统',
          desc: '教学数据，实时查看；教学管理，有据可依'
        },
        {
          name: 'dashuju',
          title: '大数据智慧管理系统',
          desc: '多维数据采集，可视化呈现；快速统筹区校学情，科学管理'
        },
        {
          name: 'parent',
          title: '家校互通互联系统',
          desc: '实时掌握孩子学习动态及在校表现；家校共育高效沟通，陪伴孩子快乐成长'
        },
        {
          name: 'area',
          title: '区域信息化管理平台',
          desc: '开放式平台，汇聚特色教学应用；区域资源共建共享，资源分发一触即达；应用灵活便捷，效果监测深度追踪'
        }
      ],
      goods: [
        {
          title: '优质资源 随取随用',
          desc: '教学资源覆盖K12全学科、全学段，如：课件、教案学案、素材、视频、试题、试卷等。',
          fold: false
        },
        {
          title: '教学全流程覆盖',
          desc: '在线轻松备课，智能高效授课，预习训练一键收发，教学设计有方，学生自主学习，成绩精准提高。',
          fold: true
        },
        {
          title: '英语专业教研 学科特色保障',
          desc: '英语学科特色内容题库支持按语言能力场景高效选择，听说读写特色练习，口语精准测评。',
          fold: true
        },
        {
          title: '开放式平台 区校本资源共建共享',
          desc: '开放式平台，汇聚特色教学应用，区域资源共建共享，资源分发一触即达。',
          fold: true
        },
        {
          title: '学情数据可视 智慧科学管理',
          desc: '学情分析帮助教师精准教学，教学大数据助力区、校领导智慧管理，科学决策。',
          fold: true
        }
      ],
      loops: [
        {
          id: 4,
          type: 'video',
          title: '新华社 | 第80届教装展学科网接受采访',
          picName: 'home-video4-cover.png',
          url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-14.mp4'
        },
        {
          id: 1,
          type: 'video',
          title: '学科网创始人陈学艺博士央视采访',
          picName: 'honer_video_cover.png',
          url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-12.mp4'
        },
        {
          id: 2,
          type: 'image',
          picName: 'honer_2.png',
          title: '中国教育技术协会会员单位'
        },
        {
          id: 3,
          type: 'image',
          picName: 'honer_3.png',
          title: '中国校园好方案卓越案例奖'
        }
      ],
      works: [
        {
          title: '学校智慧教学解决方案',
          desc1: '“教、学、管、评、测、研”智慧教学闭环，为师生减负增效，学校科学管理，让教与学更高效',
          desc2: '适合学校、代理商、集成商采购；支持纯软件或软硬件一条龙合作'
        },
        {
          title: '区域智慧教育解决方案',
          desc1: '专为区校打造，助力学校智慧教学，辅助区域统筹管理，实现区校一体化建设，促进区域教育资源均衡配置',
          desc2: '适合教育局、电教馆等教育主管单位采购；支持纯软件、软硬件一条龙合作，及定制服务'
        }
      ],
      video: {
        visible: false,
        url: ''
      }
    }
  },
  methods: {
    lookVideo: function (item) {
      this.video.url = item.url
      this.video.title = item.title
      this.video.visible = true
    }
  }
}
</script>

<style scoped>
.ho-mobile-home {
  background: white;
}

.ho-page-part2 {
  background: white;
  padding: 8px 8px 24px 8px;
}

.ho-page-part3 {
  background: lightgray url(../../../../assets/images/mobile/home_part3_bg.png)
    no-repeat;
  background-size: 100% 306px;
  height: 306px;
  padding: 8px 8px 0 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
}

.ho-page-part3 ul {
  width: calc(2250px + 160px);
}

.ho-scroll {
  width: 100%;
  padding: 8px;
  overflow-x: auto;
}

.ho-scroll::-webkit-scrollbar {
  width: 0 !important;
}
.ho-scroll::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.ho-page-part3 li {
  float: left;
  width: 225px;
  background: #f9fcff;
  border: 1px solid #dbedff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  height: 190px;
  padding: 16px;
  font-size: 12px;
  color: #666666;
  line-height: 24px;
  margin-right: 16px;
}

.ho-page-part3 li p.title {
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.ho-page-part5 {
  min-height: 306px;
  background-color: #f5f5f5;
  padding: 0 20px;
}

.ho-part5-item {
  font-size: 12px;
  margin-bottom: 16px;
}

.ho-page-part5 >>> .van-swipe__indicator {
  background-color: #d8d8d8;
}

.ho-loop-div {
  position: relative;
}

.ho-play-circle {
  position: absolute;
  top: calc(50% - 22px - 16px);
  left: calc(50% - 22px);
}

.ho-page-part6 {
  padding: 24px 16px;
}

.ho-page-part6 li {
  border: 1px solid #0080ff;
  border-radius: 10px;
  margin-bottom: 16px;
  min-height: 52px;
  overflow: hidden;
}

.work-title {
  background: #70a6fe;
  color: white;
  text-align: center;
  height: 52px;
  line-height: 52px;
}

.work-desc1 {
  font-size: 12px;
  padding: 10px;
  padding-bottom: 0;
}

.work-desc2 {
  font-size: 12px;
  font-weight: bold;
  padding: 10px;
}
</style>